import { apiHelpers, api } from './api';
import { Company, ApiResponse, CompanyFormData } from '../types/models';

export class CompanyService {
  // Получить компанию по ID (без companyId в URL)
  static async getById(id: number): Promise<ApiResponse<Company>> {
    try {
      const response = await api.get(`/Company/Get?id=${id}`);
      return apiHelpers.handleSuccess<Company>(response);
    } catch (error) {
      return apiHelpers.handleError(error);
    }
  }

  // Создать новую компанию (без companyId в URL)
  static async create(data: CompanyFormData): Promise<ApiResponse<Company>> {
    try {
      const response = await api.post('/Company/Create', data);
      return apiHelpers.handleSuccess<Company>(response);
    } catch (error) {
      return apiHelpers.handleError(error);
    }
  }

  // Обновить компанию (без companyId в URL)
  static async update(id: number, data: CompanyFormData & { id: number }): Promise<ApiResponse<void>> {
    try {
      const response = await api.put(`/Company/Update/${id}`, data);
      return apiHelpers.handleSuccess<void>(response);
    } catch (error) {
      return apiHelpers.handleError(error);
    }
  }

  // Удалить компанию (без companyId в URL)
  static async delete(id: number): Promise<ApiResponse<void>> {
    try {
      const response = await api.delete(`/Company/Delete/${id}`);
      return apiHelpers.handleSuccess<void>(response);
    } catch (error) {
      return apiHelpers.handleError(error);
    }
  }

  // Получить все компании пользователя (без companyId в URL)
  static async getUserCompanies(): Promise<ApiResponse<Company[]>> {
    try {
      const response = await api.get('/Company/GetAll');
      return apiHelpers.handleSuccess<Company[]>(response);
    } catch (error) {
      return apiHelpers.handleError(error);
    }
  }
}

